import { render } from "./PermissionsList.vue?vue&type=template&id=e23ae7f8&scoped=true"
import script from "./PermissionsList.vue?vue&type=script&lang=js"
export * from "./PermissionsList.vue?vue&type=script&lang=js"

import "./PermissionsList.vue?vue&type=style&index=0&id=e23ae7f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23ae7f8"]])

export default __exports__